import moment from "moment";
import toast from "@comps/toast";

export const getErrorProps = (errors) => {
    if (Array.isArray(errors) && !errors.length) {
        return {};
    } else if (errors === null || errors === '' || errors === "" || errors === undefined) {
        return;
    }
    return { validateStatus: 'error', help: errors };
}

export const makeRequest = async (loader, call, payload, onSuccess, onError) => {
    loader(true);
    try {
        let res = await call(payload);
        // A raw HTTP failure (413/500/timeout/...) is normalized by
        // onAxiosRejected into this same {msg, code, data} shape, with
        // code set to the HTTP status — so res.code === 401 below covers
        // both an in-app 401 and a genuine unauthorized response.
        if (res.code === 200) {
            onSuccess(res.data, res);
        } else if (res.code === 401) {
            localStorage.clear();
            window.location.href = "/";
        } else {
            if (onError) {
                onError(res.data, res);
            }
        }
    } catch (e) {
        if (onError) {
            onError(e.message, e);
        }
    }
    loader(false);
}

export const makeRequestStateless = async (call, payload, onSuccess, onError) => {
    try {
        let res = await call(payload);
        if (res.code === 200) {
            onSuccess(res.data, res);
            return;
        } else if (res.code === 422) {
            if (onError) {
                onError(res.data, res);
            }
        } else {
            if (onError) {
                onError([res.msg], res);
            }
        }
    } catch (e) {
        if (onError) {
            onError(e.message, e);
        }
    }
}


export const NOTIFICATION_TYPE = {
    INFO: "info",
    ERROR: "error",
    SUCCESS: "success",
    WARNING: "warning",
}

/**
 * Legacy entry point into the app's toast. Kept so the ~15 CRUD screens
 * that already call notify(title, body, type) keep working, but it now
 * renders the same top-right toast as everything else — see
 * src/wrappers/toast.jsx.
 */
export const notify = (title, message, type = NOTIFICATION_TYPE.SUCCESS) => {
    const show = toast[type] || toast.info;
    show(title, message);
}


export const hasPermission = (key, all_permissions) => {
    if (process.env.REACT_APP_ENV === "local") {
        return true;
    }

    if (!all_permissions.length) {
        all_permissions = JSON.parse(localStorage.getItem("moduleList"));
    }

    if (!all_permissions) {
        all_permissions = [];
        return false;
    }

    if (key === "always") {
        return true;
    }

    return all_permissions.includes(key);

}
export const replaceById = (data, each) => {
    return data.map(obj => (each.id === obj.id ? each : false) || obj);
}

export const removeById = (data, id) => {
    return data.filter(function (value, index, arr) {
        return value.id !== id;
    });
}

const formatDate = (date, format) => {
    return moment(date).format(format);
}

export const formatFullYearOnly = (date) => {
    return formatDate(date, 'YYYY');
}

export const formatYearOnly = (date) => {
    return formatDate(date, 'YY');
}

export const formatMonthOnly = (date) => {
    return formatDate(date, 'm');
}

export const formatDayOnly = (date) => {
    return formatDate(date, 'd');
}

export const formatCompleteData = (date) => {
    return formatDate(date, 'MM DD, YYYY');
}

export const formatCompleteDataTime = (date) => {
    return formatDate(date, 'MMMM DD, YYYY hh:mm A');
}

/**
 * A treatment plan's IPR/attachment columns are JSON held in text
 * columns, and not every row on file holds a well-formed list: plans
 * written before those columns existed carry null, and a partially
 * saved one can carry an empty string. `JSON.parse(null)` returns null
 * rather than throwing, so the crash landed one line later on `.map`,
 * taking the whole case screen down with it.
 *
 * Anything that is not a list reads as an empty list.
 */
export const parseJsonList = (value) => {
    if (Array.isArray(value)) {
        return value;
    }
    if (typeof value !== 'string' || value.trim() === '') {
        return [];
    }
    try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
        return [];
    }
}
